import { Card, DataDisplay, Grid, pn, useElementBreakpoints } from "@compass/core";
import { User, UserViewResource } from "generated/openApi";
import { useDateTime } from "hooks";
import "moment-timezone";

export const SystemInfo = (props: { user: User; setUser: (value: User) => void; viewResource: UserViewResource }) => {
  const { breakpointsRef, smallFieldBreakpoints } = useElementBreakpoints();
  const properties = props.viewResource.properties || [];
  const formatDateTime = useDateTime();

  const createdField = () => {
    var propertyName = pn<User>("createdDate");
    var property = properties.find((x) => x.propertyName === propertyName);

    return <DataDisplay label={property?.displayName}>{formatDateTime(props.user.createdDate)}</DataDisplay>;
  };

  const registeredDateField = () => {
    var propertyName = pn<User>("registeredDate");
    var property = properties.find((x) => x.propertyName === propertyName);

    return <DataDisplay label={property?.displayName}>{formatDateTime(props.user.registeredDate)}</DataDisplay>;
  };

  const passwordChangedDateField = () => {
    var propertyName = pn<User>("lastPasswordChangedDate");
    var property = properties.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>{formatDateTime(props.user.lastPasswordChangedDate)}</DataDisplay>
    );
  };

  const passwordExpirationDateField = () => {
    var propertyName = pn<User>("passwordExpirationDate");
    var property = properties.find((x) => x.propertyName === propertyName);

    return <DataDisplay label={property?.displayName}>{formatDateTime(props.user.passwordExpirationDate)}</DataDisplay>;
  };

  const lastLoginDateField = () => {
    var propertyName = pn<User>("lastLoginDate");
    var property = properties.find((x) => x.propertyName === propertyName);

    return <DataDisplay label={property?.displayName}>{formatDateTime(props.user.lastLoginDate)}</DataDisplay>;
  };

  const lastLockedDateField = () => {
    var propertyName = pn<User>("lastLockedDate");
    var property = properties.find((x) => x.propertyName === propertyName);

    return <DataDisplay label={property?.displayName}>{formatDateTime(props.user.lastLockedDate)}</DataDisplay>;
  };

  return (
    <Card header={"System"}>
      <Grid ref={breakpointsRef} container spacing="sm">
        <Grid item xs={smallFieldBreakpoints}>
          {createdField()}
        </Grid>

        <Grid item xs={smallFieldBreakpoints}>
          {registeredDateField()}
        </Grid>

        <Grid item xs={smallFieldBreakpoints}>
          {passwordChangedDateField()}
        </Grid>

        <Grid item xs={smallFieldBreakpoints}>
          {passwordExpirationDateField()}
        </Grid>

        <Grid item xs={smallFieldBreakpoints}>
          {lastLoginDateField()}
        </Grid>

        <Grid item xs={smallFieldBreakpoints}>
          {lastLockedDateField()}
        </Grid>
      </Grid>
    </Card>
  );
};
